// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./style.css
// module id = FWi5
// module chunks = 1